import { useLocation, useNavigate } from "react-router-dom";
import { capitalizeWords } from "./capitalizeWords";
import { subDays } from "date-fns";
import formatDate from "./dateUtils";
import avatar from "../../assets/images/avatar.webp";
import {
  getStatusText,
  getStatusColor,
} from "./../../pages/LeaveManagement/leaveManagementFunctions";

const TotalLeaveApprovedTable = () => {
  const location = useLocation();
  const approvedLeaves = location.state.approvedLeaves;
  const navigate = useNavigate();

  // console.log("approvedLeaves", approvedLeaves)

  return (
    <div className="board__layout">
      <div className="section-header">
        <div className="header__titles">
          <button onClick={() => navigate("/leavemanagement")}>
            <span>
              <i className="ri-arrow-left-s-line"></i>
            </span>
            BACK
          </button>
          <h4>Total Leaves Approved</h4>
        </div>
      </div>

      <table className="table">
        <thead>
          <tr>
            <th>SL No.</th>
            <th colSpan="2">Employee Details</th>
            <th>Applied Date</th>
            <th>Leave Start Date</th>
            <th>Leave End Date</th>
            <th>No Of Days</th>
            <th>Leave Type</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {approvedLeaves
            .filter(
              (leave) =>
                (leave.is_approved || leave.is_hr_approved) &&
                new Date(leave.apply_date) >= subDays(new Date(), 180),
            )
            .map((leave, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td className="leave_empImage">
                  <img
                    src={
                      leave?.user?.profile_picture
                        ? leave?.user?.profile_picture
                        : avatar
                    }
                    alt="Employee"
                  />
                </td>
                <td className="leave_empDetails">
                  <div className="leave_empName">
                    {capitalizeWords(leave?.user?.employee_full_name)}
                  </div>
                  <div className="leave_designation">
                    {leave?.user?.roles[0]?.role_name}
                  </div>
                  <div className="leave_id">ID:{leave?.user?.employee_id}</div>
                </td>
                <td>{formatDate(leave.apply_date)}</td>
                <td>{formatDate(leave.leave_from)}</td>
                <td>{formatDate(leave.leave_to)}</td>
                <td>{leave.days_count}</td>
                <td>{leave.leave_type}</td>
                <td style={{ color: getStatusColor(leave) }}>
                  {getStatusText(leave)}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default TotalLeaveApprovedTable;
